// extracted by extract-css-chunks-webpack-plugin
module.exports = {"button":"_2YndgB","pageLogin":"_2JHHeO","right":"_1VW4SD","left":"_19ao-u","icon":"_1gl_7Y"};